/*
	Gera uma string para inline styling
	compatível com as variáveis css injetadas
	em um elemento pelo applyHSLColorMappings
*/
export default index =>  
	index 
	? `--clr-h: var(--clr-h-${index}); --clr-s: var(--clr-s-${index}); --clr-l: var(--clr-l-${index}); ` 
	: ''
